<template>
	<form class="row g-3" @submit.prevent="checkIfEmailIsTakenAndSignUp()">
		<div class="col-6">
			<label for="input-publishing-company" class="form-label fw-bold">Publishing Company</label>
			<input type="text" class="form-control" id="input-publishing-company" v-model="loginData.company" required>
		</div>
		<div class="col-6">
			<label for="input-country" class="form-label fw-bold">Country</label>
			<select id="input-country" class="form-select" v-model="loginData.country" required>
				<option disabled selected>Choose...</option>
				<option
					v-for="(countryName, countryISO) in countriesList"
					:key="'country-' + countryISO"
					:value="countryISO">{{ countryName }}</option>
			</select>
		</div>

		<div class="col-md-6">
			<label for="input-first-name" class="form-label fw-bold">First Name</label>
			<input type="text" class="form-control" id="input-first-name" v-model="loginData.first_name" required>
		</div>
		<div class="col-md-6">
			<label for="input-last-name" class="form-label fw-bold">Last Name</label>
			<input type="text" class="form-control" id="input-last-name" v-model="loginData.last_name" required>
		</div>

		<div class="col-md-12">
			<label for="input-email" class="form-label fw-bold">Email</label>
			<input type="email" class="form-control" id="input-email" v-model="loginData.email" required>
		</div>
		<div class="col-12">
			<div class="form-check">
				<input class="form-check-input" type="checkbox" id="check-terms" v-model="loginData.accept_terms" required>
				<label class="form-check-label" for="check-terms">
					I agree with the <u><a href="/terms" target="_blank">Terms and Conditions</a></u>
				</label>
			</div>
		</div>

		<div class="col-12 mt-0">
			<div class="form-check">
				<input class="form-check-input" type="checkbox" id="check-newsletter" v-model="loginData.agree_newsletter" required>
				<label class="form-check-label" for="check-newsletter">
					I agree to receive monthly email marketing from Babel-Bridge
				</label>
				<small class="d-block">(opt-out easy from your Account Settings, should you change your mind)</small>
			</div>
		</div>

        <div class="mt-0">
			<small>Non-disclosure: You agree that the material you access will only be read for work and only shared professionally.</small>
		</div>

		<div class="col-12 text-center">
			<button type="submit" class="btn dm-btn-padding" 
				v-if="registering"
				disabled>
				Registering... <svg-icon icon="fa-spinner" class="dm-spinner" />
			</button>

			<button type="submit" class="btn dm-btn-padding" v-else>Register</button>
		</div>

		<div class="col-12 text-center">
			Already have an account? 
			
			<a 
				v-if="login_link"
				:href="login_link" 
				class="fw-bold text-decoration-underline">
				Log in!
			</a>
			
			<a 
				v-else
				href="" 
				@click.prevent="$emit('showSignInModal')" 
				class="fw-bold text-decoration-underline">
				Log in!
			</a>
		</div>
	</form>
</template>

<script>
import { countriesListMixin } from '../../../../mixins/countriesListMixin';
export default {
	
	mixins: [countriesListMixin],

	props: ['login_link'],

	data() {
		return {
			loginData: {
				company: '',
				country: '',
				first_name: '',
				last_name: '',
				email: '',
				accept_terms: '',
				agree_newsletter: '',
			},
			errors: null,

			registering: false,
		}
	},

	methods: {
		checkIfEmailIsTakenAndSignUp() { 
			this.registering = true;
			var self = this;

			axios.post('/api/email-exists', {email: this.loginData.email})
				.then(function (response) {
					let emailExists = response.data.email_exists;

					if (emailExists) {
						self.$emit('closeAllModals');
						self.registering = false;
						self.showEmailAlreadyTakenPopup();
					} else {
						self.signUp();
					}
				})
				.catch(error => {
					self.errors = error.response.data.errors
                    console.log(error)
                });
		},

		showEmailAlreadyTakenPopup() {
			var other = this;

			this.$swal({
				title: "That email is already taken!",
				text: "This email is already in use. Please sign into your account or use a different email address",
				icon: "info",
				confirmButtonText: "Sign In",
				showCancelButton: true,
				cancelButtonText: "New Email",
				customClass: {
					confirmButton: "btn btn-success",
					cancelButton: "btn btn-default"
				}
			}).then((result) => {
				if (result.isConfirmed) {
					other.$emit('showSignInModal');
				} else {
					other.$emit('showSignUpModal');
				}
			});
		},
		signUp() { 
			this.registering = true;
			var self = this;

			axios.post('/editors/register', this.loginData)
				.then(function (response) {
					self.showConfirmationPopup();
				})
				.catch(error => {
					self.errors = error.response.data.errors
                    console.log(error)
                });
		},

		showConfirmationPopup() {
			this.$emit('closeAllModals');
			var self = this;
			this.$swal({
				title: "You've successfuly submitted your application",
				text: "Our Admin will review it and get back to you shortly.",
				icon: "success",
			}).then(function () {
				window.location.href = "/";
			});
		},
	},
}
</script>
